import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import useAccounts from '../../../hooks/useAccounts';
import { useGetItemsQuery } from '../../../services/dashboardService';
import { FullPageWrapper } from '../../custom/IndividualMappingLayout';
import amIVisible from '../../../componentControl/registry';

export const IndividualPoProductMapping = ({ formik }) => {

    const { t } = useTranslation()

    const [isLoadingAccounts, inventoryAccounts] = useAccounts('inventory');
    
    const [, cogsAccounts] = useAccounts('cogs');

    let listOfAccounts = inventoryAccounts

    if (amIVisible("show expense account in inventory")) {
      listOfAccounts = [...inventoryAccounts, ...cogsAccounts]
    }

    const { currentSw } = useSelector(state => state.dashboard)

    const { items, isSentPurchaseOrder, trackInventory, isSentCogs } = formik.values;

    const { productLabels } = useSelector(state => state.dashboard)

    const isDynamicMapping = amIVisible("enter field for product and categories individual")

    const { isLoading, isFetching } = useGetItemsQuery({
        recordItems: true
    }, {
        skip: isDynamicMapping,
        selectFromResult: ({ data, ...rest }) => {
            let labels = data?.map((item) => {
                return {
                    label: item.name,
                    value: item.id
                }
            })

            labels = _.filter(labels, item => {
                return !_.keys(_.pickBy(items, (items) => items !== '')).includes(item?.value + '')
            })
     
            return {
                data: labels,
                ...rest
            }
        }
    })

    let extraProps = {
        column2: "COGS",
        cogsAccounts
    }

    if (isSentPurchaseOrder && !trackInventory && !isSentCogs) {
        extraProps = {}
    }

    return (
        <>
            <FullPageWrapper
                title={t('Map COGS and Inventory By Product')}
                fullPageDesp={t(`Individual products can be mapped to unique accounts in ${currentSw}. All unassigned and new products will be assigned to the default product account.`, { swName: currentSw })}
                formik={formik}
                formikFieldName={"poItemsMapping"}
                isLoading={isLoading || isFetching}
                isAccountsLoading={isLoadingAccounts}
                heading={"Product"}
                column1="Inventory"
                isDynamicMapping={isDynamicMapping}
                options={listOfAccounts}
                labelOption={productLabels}
                advanceMapping
                {...extraProps}
                rowLoaderProps={{
                    box: true,
                    rows: 10
                }}
            />
        </>
    )
}